import { baseUrl, discernUrl } from "./baseUrl";
import { request } from "@clover/ashe-libs";
import { sendLog } from "../libs/sendLog";

const params = new URLSearchParams(location.search);
const pageIdEcpt = params.get("pageIdEcpt");
const activityIdEcpt = params.get("activityIdEcpt");
const url = `${baseUrl}/html/common/activity/page`;
const tempUrl = `${baseUrl}/html/common/activity/test/page`;

export const getAppData = async (pageId?: string) => {
  const query = new URLSearchParams(location.search);
  let hostUrl = url;
  if (query.has("test") && query.get("test") === "1") {
    hostUrl = tempUrl;
  }

  try {
    sendLog("pef", "General_Operation_Activity_Before_Fetch_PageData", {
      pageIdEcpt,
      activityIdEcpt,
    });
  } catch (error) {}
  try {
    const res = (await request(hostUrl, "post", {
      pageIdEcpt: pageId ? pageId : pageIdEcpt,
      activityIdEcpt,
    })) as unknown as {
      code: number;
      message: string;
      data: any;
    };

    if (res.code === 0 && res.data && res.data.ext) {
      res.data.ext = JSON.parse(res.data.ext);
    }

    sendLog("pef", "General_Operation_Activity_Fetch_PageData_Response_Code", {
      pageIdEcpt,
      activityIdEcpt,
      activityPageResCode: res.code,
    });
    return res;
  } catch (error) {
    sendLog("pef", "General_Operation_Activity_Fetch_PageData_Abnormal", {
      pageIdEcpt,
      activityIdEcpt,
    });

    console.log("getAppData error", error);
    throw error;
  }
};

export const getAttribuiteId = async (pageIdEcpt?: string) => {
  const res = await request<any>(`${discernUrl}/activity/outer/report`, "post", { businessId: pageIdEcpt });
  return res.data as string;
};
